import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Location, NgClass, NgIf } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { NgxToastrService } from '../../../_services/ngx-toastr/ngx-toastr.service';
import { HttpServiceService } from '../../../services/http-service.service';
import { USER_PERMISSIONS } from '../../../app.constants';
import { LocalStorageService } from '../../../services/local-storage.service';

@Component({
  selector: 'app-owner-overview',
  imports: [NgClass , RouterModule, NgIf],
  templateUrl: './owner-overview.component.html',
  styleUrl: './owner-overview.component.css'
})
export class OwnerOverviewComponent {
 
  currentUrl: string = '';
  userId : string = '';
  ownerProfilePicForm! : FormGroup;
  @Output() profileDetailsEvent  = new EventEmitter();;
  private updateProfilePicSubscription?: Subscription;
  private getUserDetailsSubscription?: Subscription;
  userInfo : any;
  userType : string = '';
  private authService = inject(LocalStorageService);
  constructor(private router: Router, private location: Location, private route: ActivatedRoute, private fb: FormBuilder, private alertService: NgxToastrService, private httpService : HttpServiceService) {
    this.ownerProfilePicForm = this.fb.group({
      profile_image: [''],
    });
  }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.userId = params.get('id') ?? '';
      this.userType = params.get('type') ?? '';
      this.currentUrl = this.router.url;
      //console.log(this.currentUrl);
      this.getUserDetailsById();
    });    
  }

  updateCoverPhoto(event : Event){
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files && inputElement.files[0]) {
      const file = inputElement.files[0]; // Get the selected file
      const reader = new FileReader();  
      reader.onload = () => {
        this.userInfo.profile_image = reader.result as string; // Convert file to data URL
      };  
      reader.readAsDataURL(file); // Read file as Data URL
      this.ownerProfilePicForm.patchValue({ profile_image: file });
      this.ownerProfilePicForm.get('profile_image')?.updateValueAndValidity(); 
      this.updateProfilePic();   
    }
  }

  handleImageError(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/images/pic7.jpg';
  }

  updateProfilePic(){
    const formData = new FormData();
    formData.append('profile_image', this.ownerProfilePicForm.get('profile_image')?.value);
    this.updateProfilePicSubscription = this.httpService.editUser(formData, this.userId).subscribe({
        next : (resp) => {          
          this.alertService.success(resp.message, "toast-top-right");
        }
    });
  }

  getUserDetailsById(){
    this.getUserDetailsSubscription = this.httpService.getUser(this.userId).subscribe({
      next : (response) => {
        this.userInfo = response.data;
       this.notifyParent(response.data);
      }
    })
  }

  notifyParent(data : any){
    this.profileDetailsEvent.emit(data);
  }

  ngOnDestroy(){
    this.updateProfilePicSubscription?.unsubscribe();
    this.getUserDetailsSubscription?.unsubscribe();
  }

  get checkUserInfoTab(){
      return this.authService.checkPermission(USER_PERMISSIONS.USER_INFO.USER_INFO_TAB);
  }

  get checkUserDocumentsTab(){
    return this.authService.checkPermission(USER_PERMISSIONS.USER_INFO.USER_DOCUMENTS_TAB);
  }

  get checkUserLeaseTab(){
    return this.authService.checkPermission(USER_PERMISSIONS.USER_INFO.USER_LEASE_TAB);
  }

  get checkUserBillsTab(){
    return this.authService.checkPermission(USER_PERMISSIONS.USER_INFO.USER_BILLS_TAB);
  }

  get checkUserBankTab(){
    return this.authService.checkPermission(USER_PERMISSIONS.USER_INFO.USER_BANK_TAB);
  }

  get checkUserLocalContactTab(){
    return this.authService.checkPermission(USER_PERMISSIONS.USER_INFO.USER_LOCAL_TAB);
  }
  
  
}
